
export function transformToString(any) {
  switch (typeof any) {
    case 'object':
      return JSON.stringify(any);
    case 'function':
      return `${any}`;
    default:
      return `${any}`;
  }
}

export function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}
